const initialState = {
    captcha: {
        public_key: null,
        enable_global: false,
        login: false,
        account_creation: false,
        password_reset: false,
        contact_us: false,
        shipping_address_form: false,
        billing_address_form: false,
        sweepstakes: false,
    },
    isFulfilled: false,
};

export { initialState as default };
//# sourceMappingURL=initialState.js.map
